<script lang="ts">
  let { children } = $props()
</script>

<thead>{@render children?.()}</thead>
